import { StyledTooltipProps } from '@gorila-shared-ui/components';
import { StatefulTooltip } from 'baseui/tooltip';
import { useStyles } from '../../hooks/useStyles';

const StyledTooltip = ({
  children,
  content,
  showArrow = true,
  placement,
  ignoreBoundary = false,
  popoverMargin = 5,
}: Readonly<StyledTooltipProps>) => {
  const { css } = useStyles();

  return (
    <StatefulTooltip
      content={() => content}
      showArrow={showArrow}
      autoFocus
      popoverMargin={popoverMargin}
      placement={placement}
      ignoreBoundary={ignoreBoundary}
    >
      <span
        className={css({
          lineHeight: 0,
          height: 'fit-content',
        })}
      >
        {children}
      </span>
    </StatefulTooltip>
  );
};

export default StyledTooltip;
